// Types partagés pour l'application Chiffrage Design

export type Univers = 'Vente' | 'AccessMH' | 'ECE' | 'ECP' | 'APP' | 'Vision' | 'IA';
export type TailleShirt = '—' | 'XS' | 'S' | 'M' | 'L' | 'XL';
export type Statut = 'En cours' | 'Attribués' | 'Partiel';

export interface Chiffrage {
    id: number;
    created_at: string;
    univers: Univers;
    sujet: string;
    taille_cx: TailleShirt;
    taille_lead_ux: TailleShirt;
    taille_lead_ui: TailleShirt;
    taille_product: TailleShirt;
    jours_cx: number;
    jours_lead_ux: number;
    jours_lead_ui: number;
    jours_product: number;
    total_jours: number;
    statut: Statut;
    numero_orchestra: string | null;
    jours_attribues: number | null;
    differentiel: number | null;
    lien_jira: string | null;
}

export interface CreateChiffrageInput {
    univers: Univers;
    sujet: string;
    taille_cx: TailleShirt;
    taille_lead_ux: TailleShirt;
    taille_lead_ui: TailleShirt;
    taille_product: TailleShirt;
}

// Barème des jours par taille et rôle
export const BAREME: Record<string, Record<Exclude<TailleShirt, '—'>, number>> = {
    cx: { XS: 2, S: 5, M: 10, L: 15, XL: 25 },
    lead_ux: { XS: 2, S: 5, M: 8, L: 12, XL: 16 },
    lead_ui: { XS: 2, S: 5, M: 8, L: 12, XL: 16 },
    product: { XS: 3, S: 5, M: 14, L: 25, XL: 35 },
};

export const TAILLES: TailleShirt[] = ['—', 'XS', 'S', 'M', 'L', 'XL'];
export const UNIVERS: Univers[] = ['Vente', 'AccessMH', 'ECE', 'ECP', 'APP', 'Vision', 'IA'];
export const STATUTS: Statut[] = ['En cours', 'Attribués', 'Partiel'];

export function calculateJours(taille: TailleShirt, role: string): number {
    if (taille === '—') return 0;
    return BAREME[role]?.[taille] ?? 0;
}

export const ROLES = [
    { key: 'cx', label: 'CX' },
    { key: 'lead_ux', label: 'Lead UX' },
    { key: 'lead_ui', label: 'Lead UI' },
    { key: 'product', label: 'Product' },
] as const;
